<template>
    <div class="pop_table">
        <table class="tb-list01" summary="유관시설목록">
            <caption>유관시설목록</caption>
            <colgroup>
                <col style="width:15%">
                <col style="width:20%">
                <col style="width:25%">
                <col style="width:40%">
            </colgroup>
            <thead>
            <tr>
                <th>구분</th>
                <th>시설명</th>
                <th>전화번호</th>
                <th>주소</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="safetyCenter in safetyCenterList">
                    <td>소방서(안전센터)</td>
                    <td>{{ safetyCenter.val2 }}</td>
                    <td>{{ safetyCenter.val4 }}</td>
                    <td class="alignL"><div class="text-ellipsis">{{ safetyCenter.val3 }}</div></td>
                </tr>
                <tr v-for="medicalFac in medicalFacList">
                    <td>의료기관</td>
                    <td>{{ medicalFac.val1 }}</td>
                    <td>{{ medicalFac.val8 }}</td>
                    <td class="alignL"><div class="text-ellipsis">{{ medicalFac.val7 }}</div></td>
                </tr>
                <tr v-for="police in policeList">
                    <td>경찰서</td>
                    <td>{{ police.val4 }}<span v-show="police.val5 !== ''">({{ police.val5 }})</span></td>
                    <td>{{ police.val7 }}</td>
                    <td class="alignL"><div class="text-ellipsis">{{ police.val6 }}</div></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'SafetyInfoReleatedOrgList',
    computed: {
        ...mapGetters({
            safetyCenterList: 'getSafetyCenterList',
            medicalFacList: 'getMedicalFacList',
            policeList: 'getPoliceList',
        }),
    },
    created() {
        if(this.safetyCenterList.length === 0) {
            this.$store.dispatch('FETCH_SAFETYCENTER_LIST');
        }
        if(this.medicalFacList.length === 0) {
            this.$store.dispatch('FETCH_MEDICALFAC_LIST');
        }
        if(this.policeList.length === 0) {
            this.$store.dispatch('FETCH_POLICE_LIST');
        }
    }
}
</script>